import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { Layout } from 'antd';
import Routers from './routerMap';
//import { store } from 'Store/index';
import { isPdfOnlineDomain,getPrivacyPolicyUrl, getTermsOfServiceUrl } from 'Utils/utils';

//const { SubMenu } = Menu;
const { Content } = Layout;

export default function ContentLayout() {
  // props.location.pathname
  return (
    <Content>
      <Switch>
        {Routers.map((item, index) => {
          return (
            <Route
              exact
              key={index}
              path={item.path}
              render={(props) => {
                if('/download-share' == item.path && !isPdfOnlineDomain() ){
                  return(
                    <Redirect
                          to={{
                            pathname: '/',
                            state: { from: props.location },
                          }}
                        />
                  )
                }
                if ('/privacy-policy' == item.path) {
                  window.location.href = getPrivacyPolicyUrl();
                  return null;
                } else if ('/terms-of-service' == item.path ||
                            '/term-of-use' == item.path) {
                  window.location.href = getTermsOfServiceUrl();
                  return null;
                }
                return <item.component {...props} />;
                // if (!item.auth) {
                //   return <item.component {...props} />;
                // } else if (store.userStore.hasSignIn) {
                //   return <item.component {...props} />;
                // } else {
                //   return (
                //     <Redirect
                //       to={{
                //         pathname: '/',
                //         state: { from: props.location },
                //       }}
                //     />
                //   );
                // }
              }}
            />
          );
        })}
        {/* <Route exact path="/" component={ViewerPage}></Route>
        <Route exact path="/subscribe" component={SubscribePage}></Route>
        <Route exact path="/privacy-policy" component={PrivacyPolicyPage}></Route>
        <Route exact path="/term-of-use" component={TermsOfUsePage}></Route>
        <Route exact path="/terms-of-service" component={TermsOfUsePage}></Route>
        <Route exact path="/feedback" component={FeedbackPage}></Route> */}
        {/* <Route component={NotFoundPage}/> */}
      </Switch>
    </Content>
  );
}
